import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DecisionTree, DecisionTreeListData, DecisionTreesState } from '../../types/decisionTrees.types';

const initialState: DecisionTreesState = {
  trees: [],
  selectedTree: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
    hasMorePages: false,
  },
  search: '',
  sort: {
    field: 'displayOrder',
    order: 'asc',
  },
};

const decisionTreesSlice = createSlice({
  name: 'decisionTrees',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setTrees(state, action: PayloadAction<DecisionTreeListData>) {
      state.trees = action.payload.trees;
      state.pagination.totalPages = action.payload.totalPages;
      state.pagination.totalRecords = action.payload.totalRecords;
      state.pagination.hasMorePages = action.payload.hasMorePages;
    },
    setSelectedTree(state, action: PayloadAction<DecisionTree | null>) {
      state.selectedTree = action.payload;
    },
    clearSelectedTree(state) {
      state.selectedTree = null;
    },
    setPage(state, action: PayloadAction<number>) {
      state.pagination.page = action.payload;
    },
    setPageSize(state, action: PayloadAction<number>) {
      state.pagination.pageSize = action.payload;
      state.pagination.page = 1;
    },
    setSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
      state.pagination.page = 1;
    },
    setSort(state, action: PayloadAction<{ field: string; order: string }>) {
      state.sort = action.payload;
      state.pagination.page = 1;
    },
    addTree(state, action: PayloadAction<DecisionTree>) {
      state.trees.unshift(action.payload);
      state.pagination.totalRecords += 1;
    },
    updateTree(state, action: PayloadAction<DecisionTree>) {
      const index = state.trees.findIndex((t) => t.id === action.payload.id);
      if (index !== -1) {
        state.trees[index] = action.payload;
      }
    },
    removeTree(state, action: PayloadAction<string>) {
      state.trees = state.trees.filter((t) => t.id !== action.payload);
      state.pagination.totalRecords -= 1;
    },
  },
});

export const {
  setLoading,
  setError,
  setTrees,
  setSelectedTree,
  clearSelectedTree,
  setPage,
  setPageSize,
  setSearch,
  setSort,
  addTree,
  updateTree,
  removeTree,
} = decisionTreesSlice.actions;

export default decisionTreesSlice.reducer;
